import { Strategy } from '../../types/strategy-entities';

export interface StrategyState {
  loading: boolean;
  loaded: boolean;
  pending: boolean;
  preTradeIndicatorsPending: boolean;
  error?: string | undefined;
  strategies: Strategy[];
}

export const initialState: StrategyState = {
  loading: false,
  loaded: false,
  pending: false,
  preTradeIndicatorsPending: false,
  strategies: []
};
